var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M 230 180     L 230 20     A 10 10 0 0 0 220 10     L 20 10     A 10 10 0 0 0 10 20     L 10 140     A 10 10 0 0 0 20 150     L 200 150   Z",
    fill: "white",
    stroke: "#9B51E0",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackDialog);
export default __webpack_public_path__ + "static/media/FeedbackDialog.acaf8e430439b5914688133f99e7800f.svg";
export { ForwardRef as ReactComponent };